/**
 * Side-effect module: installs the web Platform. main.tsx imports it FIRST: the UI store and Football 101 progress
 * read storage while their modules initialise, so the platform must be in place before the app graph evaluates.
 */
import { browserPlatform } from './browser-platform';
import { setPlatform } from '@hf/client-core/platform';

setPlatform(browserPlatform());
